/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Editor_Raw_Mode_ToastInputs */



/**
* | output |
* | --- |
* | "{name} switched to source editing" |
*
* @param {Editor_Raw_Mode_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_raw_mode_toast = /** @type {((inputs: Editor_Raw_Mode_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Raw_Mode_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} hat zum Quelltext-Modus gewechselt`)
	return /** @type {LocalizedString} */ (`${i?.name} switched to source editing`)
});